import { render, staticRenderFns } from "./SignUpPage.vue?vue&type=template&id=6911454a&scoped=true&"
import script from "./SignUpPage.vue?vue&type=script&lang=ts&"
export * from "./SignUpPage.vue?vue&type=script&lang=ts&"
import style0 from "./SignUpPage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SignUpPage.vue?vue&type=style&index=1&id=6911454a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6911454a",
  null
  
)

export default component.exports
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QRadio,QCheckbox});
